module.exports = __webpack_public_path__ + "img/validation.9cdfa74e.svg";